export class ItemSeguro {
    seguro;
    tipo_seguro;
    mensaje;
    cobertura_atencion;
    constructor() {
        this.seguro = "";
        this.tipo_seguro = "";
        this.mensaje = "";
        this.cobertura_atencion = "";
    }
}
